module.exports = __webpack_public_path__ + "catalog/items/school-desk-double/wood.jpg";